import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["tokenInput", "typeInput", "emailInput", "response", "copy"]

  copy() {
    navigator.clipboard.writeText(this.responseTarget.textContent)
    this.showCopied(this.copyTarget)
  }

  showCopied(clickedElement) {
    const originalText = clickedElement.innerHTML
    clickedElement.innerHTML = "Copied!"
    setTimeout(() => {
      clickedElement.innerHTML = originalText
    }, 1000)
  }

  sendPushNotification() {
    const deviceRegistrationToken = this.tokenInputTarget.value
    const pushNotificationType = this.typeInputTarget.value
    const email = this.emailInputTarget.value
    const urlPath = this.tokenInputTarget.dataset.actionPath

    Rails.ajax({
      url: `${urlPath}?token=${deviceRegistrationToken}&type=${pushNotificationType}&email=${email}`,
      type: 'POST',
      credentials: "same-origin",
      success: (data, _status, _xhr) => {
        this.responseTarget.textContent = data.message
        this.showHideCopyAccessTokenButton(pushNotificationType)
      },
      error: (response, _status, _xhr) => {
        this.responseTarget.textContent = response.message
        this.showHideCopyAccessTokenButton(pushNotificationType)
      },
    })
  }

  showHideCopyAccessTokenButton(pushNotificationType) {
    if (pushNotificationType === "FCM_TOKEN") {
      this.copyTarget.classList.remove("tw-hidden")
    } else {
      this.copyTarget.classList.add("tw-hidden")
    }
  }

}
